<template>
  <div v-loading.fullscreen.lock="fullscreenLoading"></div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { ENV, DomainNameMap } from "@/api/apiRoute";
export default {
  name: "loginIDaaS",
  data() {
    return {
      fullscreenLoading: true,
      currentTenantGuid: "",
      currentuser: {},
      codeList: [],
      tUrl: "",
      platformGuid: "1e2409b7ef0b412c2bb84e38f8fe50ba",
      appSideGuid: "03cb364e04d894a44cdb94273abffa13",
      userStatusType: 1,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const self = this;
      const code = self.$route.query.code;

      let validateUri = "http://localhost:9001/LoginIDaaS";
      let appkey = "69648538e4b0c6ac84adcc52";
      console.log("ENV", ENV);
      if (ENV === "sit") {
        // 测试环境
        // validateUri = "https://scm-operation-test.csbr.cn/LoginIDaaS";
        appkey = "69648538e4b0c6ac84adcc52";
      }
      if (ENV == "uat") {
        // uat
        // validateUri = "https://scm-operation-pre-test.cs4pl.com/LoginIDaaS";
        // idass 没有 uat
        appkey = "69648538e4b0c6ac84adcc52";
      }
      if (ENV === "pro" || ENV === "pre") {
        // 生产环境
        // validateUri = "https://scm-operation.cs4pl.com/LoginIDaaS";
        appkey = "699eba3de4b0ede30d15a072";
      }
      validateUri = window.location.origin + "/LoginIDaaS";
      const params = {
        userStatusType: self.userStatusType,
        userType: 2,
        platformGuid: self.platformGuid,
        appSideGuid: self.appSideGuid,

        // logonUser: '13900000014',

        code: code,
        appkey: appkey,
        validateUri: validateUri,
      };
      try {
        // 删除 token
        localStorage.removeItem("token");
        const { data } = await self.api.postJson(
          "/csbr-zuul/staff/login",
          params
        );
        console.log(data);
        localStorage.setItem(
          "wynToken",
          JSON.stringify(
            "670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef"
          )
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          self.$router.push("/login");
          return;
        }
        localStorage.token = data.data.token;
        localStorage.setItem("refreshToken", data.data.refreshToken);
        await self.getLastLogin();
        await self.getCurrentuser();
        await self.getAddRedis(
          this.currentTenantGuid || this.currentuser[0].guid
        );
        await self.getCodeList();
        // if (!self.codeList.length) {
        //   await self.$confirm("未能成功获取字典数据，请联系技术人员!", "提示", {
        //     confirmButtonText: "确定",
        //     showCancelButton: false,
        //     type: "warning",
        //   });
        // }
        await self.getCurrentstaff(
          self.currentTenantGuid || self.currentuser[0].guid
        );
        // await self.bindWxUnionId(latestLoginTenantGuid || data.data[0].guid);
        self.$nextTick(() => {
          self.getMenuList(self.currentTenantGuid || self.currentuser[0].guid);
        });
      } catch (error) {
        console.error("error", error);
      }
    },
    async getLastLogin() {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msCommonAdminPlatformAuthService}/user/get-latest-login-info`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      this.currentTenantGuid = data.data.latestLoginTenantGuid;
    },
    async getCurrentuser() {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        self.$router.push("/login");
        return;
      }
      if (!data.data?.length) {
        self.$message.error("当前人员未备案到药企，请联系运营人员!");
        self.$router.push("/login");
        return;
      }
      this.currentuser = data.data;
      let systemEnvironment = this.currentuser[0].systemEnvironment;
      if (this.currentTenantGuid) {
        systemEnvironment = this.currentuser.find(
          (item) => item.guid == this.currentTenantGuid
        ).systemEnvironment;
      }
      localStorage.systemEnvironment = systemEnvironment;
      self.$store.commit(
        "$_setTenantGuid",
        this.currentTenantGuid || this.currentuser[0].guid
      );

      // 设置tenantGuid
      self.tUrl &&
        (localStorage.guid =
          this.currentTenantGuid || this.currentuser[0].guid);
      localStorage.supertubeFlag = this.currentuser[0].supertubeFlag;
    },
    async getAddRedis(tenantGuid) {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
    },
    async getCodeList() {
      let that = this;
      await that.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-all`)
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            localStorage.codeList = JSON.stringify(resp.data.data);
            // this.codeList = resp.data.data;
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },
    async getCurrentstaff(tenantGuid) {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` +
          `tenantGuid=` +
          tenantGuid
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      localStorage.setItem("userInfo", JSON.stringify(data.data));
    },
    //绑定微信号
    async bindWxUnionId(tenantGuid) {
      if (this.unionId) {
        const { data } = await this.api.put(
          "/ms-common-admin-platform-auth-service/user/data/bind-webchat-user?unionId=" +
            this.unionId
        );

        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(res.data.msg);
          return;
        }
        this.$message.success("微信绑定成功");
        this.$nextTick(() => {
          this.getMenuList(tenantGuid);
        });
      } else {
        if (this.tUrl) {
          this.$router.push(`/${this.tUrl}`);
        } else {
          this.$nextTick(() => {
            this.getMenuList(tenantGuid);
          });
        }
      }
    },
    getDomainName() {
      const systemEnvironment = localStorage.systemEnvironment; // 后端环境
      console.log("systemEnvironment", systemEnvironment);
      const domainName = DomainNameMap[systemEnvironment] || "";
      console.log("domainName", domainName);
      // 检测是否为本地环境
      const isLocal =
        location.hostname === "localhost" ||
        location.hostname === "192.168.10.17";
      const targetDomain = isLocal ? location.origin : domainName;
      console.log("targetDomain", targetDomain);
      return targetDomain;
    },
    getMenuList(tenantGuid) {
      let self = this;
      let appSideGuid = self.appSideGuid;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
            `appType=01&tenantGuid=` +
            tenantGuid +
            `&appSideIdentifier=scm_operative`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("登录成功");
            self.menuList = res.data.data;
            const domainName = self.getDomainName();
            self.menuList.forEach(function (i, idx) {
              if (i.externalLinkMark == "01") {
                i.src = i.path;
                i.path = "/reportQueryList-" + idx;
                // console.log('1', i.externalLinkMark);
                if (i.children != null && i.children != "") {
                  i.children.forEach(function (j, index) {
                    index = index + 1;
                    if (j.externalLinkMark == "01") {
                      // console.log('11', j.externalLinkMark);
                      j.src = j.path;
                      j.path = "/reportQuery-" + idx + index;
                    }
                  });
                }
              }
            });
            localStorage.setItem("appSideGuid", JSON.stringify(appSideGuid));
            localStorage.setItem(
              "allMenuList",
              JSON.stringify(cloneDeep(res.data.data))
            );
            /**
             * 这里跳转需要跳转到对应的环境
             * 比如
             *    登录是从pro环境登录,此时在pro环境首页(SZ_homePageReportNew)
             *    在首页进行操作,后端环境是pre环境,那么就会从pro环境跳转到pre环境
             *    此时会存在两个域名使用同一个refreshToken
             *    refreshToken是一次性的,使用过一次就失效
             *    两个域名共用同一个refreshToken,后使用refreshToken刷新token的接口会失败,此时token会过期
             * 所以
             *    这里跳转到对应的环境,这样就是同一个域名,使用同一个refreshToken
             */
            let url = `${domainName}/LoginAccess?tenantGuid=${tenantGuid}&appSideGuid=${appSideGuid}&token=${localStorage.token}&refreshToken=${localStorage.refreshToken}`;
            if (res.data.data[0].menuName == "主页") {
              //判断工作台首页
              if (
                res.data.data[0].path == "/SZ_homePageReportNew" &&
                res.data.data[0].children
              ) {
                localStorage.setItem(
                  "reportMenuList",
                  JSON.stringify(res.data.data[0].children)
                );
              }
              //有个人首页，导航不显示个人主页菜单，直接跳转
              self.menuList = self.menuList.slice(1);
              localStorage.setItem("menuList", JSON.stringify(self.menuList));
              // self.$router.replace({
              //   path: res.data.data[0].path,
              //   query: { pageMenuGuid: res.data.data[0].guid },
              // });
              url += "&path=" + encodeURIComponent("/SZ_homePageReportNew");
              setTimeout(function () {
                window.location.href = url;
              }, 500);
            } else {
              localStorage.setItem("menuList", JSON.stringify(self.menuList));
              if (
                res.data.data[0].children != null &&
                res.data.data[0].children.length > 0
              ) {
                setTimeout(function () {
                  // self.$router.replace(res.data.data[0].children[0].path);
                  url +=
                    "&path=" +
                    encodeURIComponent(res.data.data[0].children[0].path);
                  window.location.href = url;
                }, 500);
              } else {
                // self.$router.push("/reportQueryList-0");
                url += "&path=" + encodeURIComponent("/reportQueryList-0");
                window.location.href = url;
              }
            }
          } else {
            self.$message.error(res.data.msg);
            self.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style></style>
